import { Typography } from "@mui/material";
import { FormattedNameProps, useFormattedName } from "./hooks";

export default function MixDetailsFormattedName(props: FormattedNameProps) {
  const formattedName = useFormattedName(props);

  return (
    <Typography variant="h1" sx={{ mb: 2 }}>
      {formattedName}
    </Typography>
  );
}
